@import (reference) '../../constants/spacing.module.less';

.select-plan-button {
  height: 24px;
  padding: @space-0 @space-12;
}

.select-plan-link {
  font-size: 14px;
}

.banner-padding {
  padding: @space-8 @space-12;
}

.button {
  margin-left: @space-8;
}
